import { Text } from './src/Text.ts';

customElements.define('dockit-text', Text);
